<template>
    <b-card no-body>
        <entry-header
            :active-chat="activeChat"
            :entry="entry"
            :is-expanded="isExpanded"
            :sender="sender"
            @expanded="setExpanded"
            @load-editor-content="$emit('load-editor-content')"
        />

        <b-card-body v-show="isExpanded" class="mail-message-wrapper pt-2">
            <b-spinner v-if="(!entry.metadata || iframeLoading) && entry.status !== 'declined'" />
            <font-awesome-icon v-else-if="entry.status === 'declined'" icon="times" size="2xl" />

            <iframe
                v-if="entry.metadata && entry.status !== 'declined'"
                ref="iframe"
                class="mail-message"
                sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox"
                @load="iframeLoading = false"
            />
        </b-card-body>

        <b-card-footer v-if="entry.assets && entry.assets.length > 0" v-show="isExpanded">
            <div class="mail-attachments">
                <div class="d-flex align-items-center mb-1">
                    <font-awesome-icon icon="paperclip" />
                    <h5 class="font-weight-bolder text-body mb-0 ml-50">
                        {{ entry.assets.length }}
                        {{ $t(`Attachment${entry.assets.length > 1 ? "s" : ""}`) }}
                    </h5>
                </div>

                <div class="d-flex flex-column">
                    <b-link
                        v-for="(asset, index) in entry.assets"
                        :key="asset.id"
                        :class="{ 'mt-75': index }"
                        target="_blank"
                        @click="downloadAsset(asset)"
                    >
                        <font-awesome-icon :icon="resolveContentTypeIcon(asset.contentType)" />

                        <span class="text-muted font-weight-bolder align-text-top">
                            {{ asset.originalName }}
                        </span>
                        <b-spinner v-if="downloadsPending.includes(asset.fileName)" small></b-spinner>
                    </b-link>
                </div>
            </div>
        </b-card-footer>
    </b-card>
</template>

<script>
import { BCard, BCardBody, BCardFooter, BLink, BSpinner } from "bootstrap-vue";
import { resolveContentTypeIcon } from "@/utils/chats";
import EntryHeader from "@/views/modules/email-inbox/active-chat-log-entries/components/entryHeader";
import { ref, onMounted } from "@vue/composition-api";
import { downloadFile } from "@/utils/assets";

export default {
    components: {
        BCard,
        BCardBody,
        BCardFooter,
        BLink,
        BSpinner,
        EntryHeader,
    },
    props: {
        activeChat: {
            type: Object,
            required: true,
        },
        entry: {
            type: Object,
            required: true,
        },
        sender: {
            type: Object,
            required: true,
        },
        lastEntryId: {
            type: Number | String, // Strings allowed, be generated uuid
            required: false,
        },
        setIframeProperties: {
            type: Function,
            required: true,
        },
        isSendPending: {
            type: Boolean,
            required: false,
        },
    },
    setup(props) {
        const downloadsPending = ref([]); // collection of fileNames which are pending download.
        const downloadAsset = (asset) => {
            downloadsPending.value.push(asset.fileName);

            downloadFile(asset).then(() => {
                downloadsPending.value.pop(asset.fileName);
            });
        };

        const iframe = ref(null);
        const iframeLoading = ref(true);
        const isExpanded = ref(props.entry.id === props.lastEntryId);

        onMounted(() => props.setIframeProperties(iframe, props.entry.id));

        const setExpanded = (expanded) => {
            isExpanded.value = expanded;
        };

        return {
            // To handle assets
            resolveContentTypeIcon,
            downloadsPending,
            downloadAsset,

            // To show content
            setExpanded,
            iframe,
            iframeLoading,
            isExpanded,
        };
    },
};
</script>
